import $ from 'jquery';

export default class AccordionController {
    constructor() {
        AccordionController.assignGroups();

        // Append modal dialogs from forms engine to body element
        $("[id$='SOS_Form_Widget_Container'] .modal.fade").appendTo('body');
    }

    static assignGroups() {
        const regex = /panel-member-([\S]+)/;
        const $groups = $('[class*="panel-member"]');
        $.each($groups, (index, value) => {
            const className = $(value).attr('class');
            const groupName = className.match(regex);

            const $toggles = $(value).find('.panel-toggle');
            $.each($toggles, (index2, value2) => {
                const $toggle = $(value2);
                if (groupName != null && groupName.length > 0) {
                    $toggle.data('group', groupName[1]);
                }
                $toggle.on('click', function () {
                    const target = $(this).data('target');
                    if (typeof target === 'undefined') return;

                    const $target = $(target);
                    if (!$target.hasClass('in')) {
                        const group = $(this).data('group');
                        if (typeof group !== 'undefined') {
                            const $currentin = $(`.panel-member-${group} .panel-collapse.collapse.in`);
                            const $currentinToggles = $(`.panel-member-${group} .panel-toggle:not(.collapsed)`);
                            $currentinToggles.addClass('collapsed');
                            $currentin.slideUp('fast', () => {
                                $currentin.removeClass('in');
                            });
                        }
                        $toggle.removeClass('collapsed');
                        $target.slideDown('fast', () => {
                            $target.addClass('in');
                            const $window = $(window);
                            const bottom = ($target.offset().top - $window.scrollTop()) + $target.innerHeight();
                            // Scroll to the element when it would exceed the viewport
                            if (bottom > $window.height()) {
                                $('html,body').animate({
                                    scrollTop: $(value2).offset().top - 100,
                                }, 500);
                            }
                        });
                    }
                    else {
                        $toggle.addClass('collapsed');
                        $target.slideUp('fast', () => {
                            $target.removeClass('in');
                        });
                    }
                });
            });
        });
    }

    static init() {
        $(document).ready(() => {
            new AccordionController(); // eslint-disable-line no-new
        });
    }
}
